import script from "./SellOwnCar.vue?vue&type=script&setup=true&lang=js"
export * from "./SellOwnCar.vue?vue&type=script&setup=true&lang=js"

import "./SellOwnCar.vue?vue&type=style&index=0&id=55b3d3b1&lang=css"

const __exports__ = script;

export default __exports__